<template>
  <b-container>
    <div id="rayonPageContainer" class="mb-5">
      <b-row class="mt-5" style="justify-content:center">
        <div class="title" style="width:100%">
          Rayon X
        </div>
      </b-row>
      <b-row class="justify-content-center align-items-center mt-5 mf_card_bl_spl">
        <b-col cols="3" md="4" style="text-align: center;"><img style="width:60%" :src="this.$imgPath + 'rayonX/chart-dynamic-clay.png'" alt="chart-dynamic-clay"/></b-col>
        <b-col cols="12" md="8" style="text-align:left">
          <div>Le rayon X vous permet d'effectuer des <span class="txt_purple">optimisations</span> sur vos comptes d'épargne <span class="text_purple"> selon vos besoins</span>, il vous permettra entre autre de minimiser vos frais de plateforme et de gestion où encore de limiter votre impact environnemental.</div>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col cols="12" md="6" class="">
          <Card direction="left" title="L’optimiseur de plateforme" :imgSrc="this.$imgPath + 'rayonX/wallet.png'">
            <CardContentPlatform
              :total_savings="total_savings"
              :average_platform_fees="average_platform_fees"
              :average_platform_fees_user="average_platform_fees_user"
              :platform_total_fees="platform_total_fees"
              :saving_platform_management_overall="saving_platform_management_overall"
            />
          </Card>
        </b-col>
        <b-col cols="12" md="6" class="">
          <Card direction="right" title="L’optimiseur de frais" :imgSrc="this.$imgPath + 'rayonX/analysis.png'">
            <CardContentFrais
              :total_savings="total_savings"
              :sum_assets="sum_assets"
              :average_management_fees="average_management_fees"
              :average_management_fees_user="average_management_fees_user"
              :total_management_fees_overall="total_management_fees_overall"
            />
          </Card>
        </b-col>
        <b-col cols="12" md="6" class="">
          <Card direction="left" title="Diagnostique de votre impact sur la planète" :imgSrc="this.$imgPath + 'rayonX/isr.webp'">
            <CardContentImpact
              :average_co2="average_co2"
              :average_co2_user="average_co2_user"
              :total_esg_carbon_scope1="total_esg_carbon_scope1"
              :total_esg_carbon_scope2="total_esg_carbon_scope2"
              :total_esg_carbon_scope3="total_esg_carbon_scope3"
              :total_esg_carbon_overall="total_esg_carbon_overall"
            />
          </Card>
        </b-col>
        <b-col cols="12" md="6" class="">
          <Card direction="right" title="Vue des experts" :imgSrc="this.$imgPath + 'rayonX/chart.png'">
            <CardContentExperts />
          </Card>
        </b-col>
        <b-col cols="12" md="12" class="">
          <Card direction="left" title="Diagnostique du risque" :imgSrc="this.$imgPath + 'rayonX/secure.png'">
            <CardContentRisque
              :risks="risks"
             />
          </Card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import Card from "./comps/Card.vue";
import CardContentPlatform from "./comps/CardContentPlatform.vue";
import CardContentFrais from "./comps/CardContentFrais.vue";
import CardContentImpact from "./comps/CardContentImpact.vue";
import CardContentExperts from "./comps/CardContentExperts.vue";
import CardContentRisque from "./comps/CardContentRisque.vue";
export default {
  props: [
    "average_management_fees_user",
    "average_management_fees",
    "saving_platform_securities_overall",
    "total_savings",
    "sum_assets",
    "risks",
    "average_platform_fees_user",
    "average_platform_fees",
    "saving_platform_management_overall",
    "total_management_fees_overall",
    "average_co2",
    "platform_total_fees",
    "average_co2_user",
    "total_esg_carbon_scope1",
    "total_esg_carbon_scope2",
    "total_esg_carbon_scope3",
    "total_esg_carbon_overall",
    "total_management_fees_overall",
  ],
  components: {
    Card,
    CardContentPlatform,
    CardContentFrais,
    CardContentImpact,
    CardContentExperts,
    CardContentRisque,
  },
  data() {
    return { child_component: "cardContent" };
  },
};
</script>
CardRight
<style lang="scss">
@import "./resources/sass/_variables.scss";

#rayonPageContainer {
  .title {
    text-align: center;
    font: normal normal normal 70px/89px Dosis;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .subtitle {
    text-align: center;
    font: normal normal normal 30px/40px Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
}
</style>
